<template>
  <footer>
    <div class="align">
      <p>© 2019 Все права защищены.</p>
      <a href="https://finmoll.com/upload/iblock/37e/politika-v-otnoshenii-obrabotki-pd_finmoll_1_.pdf"
         target="_blank" rel='nofollow noopener'>Политика в
        отношении обработки персональных данных</a>
      <p>Разработка сайта <b>ADMD</b></p>
    </div>
  </footer>
</template>

<script>
  export default {
    name: "footerLine"
  }
</script>

<style scoped>
  footer {background: #222721;color:#869A95;font-size: 4.4vw;height:46vw;padding: 8vw 0;}
  .align {height: 100%;display: flex;align-items: center;justify-content: center;flex-wrap: wrap;text-align: center}
  p {}
  a {color: inherit;}
  b{color:white;}
  @media screen and (min-width: 760px) {
    footer {padding: 0;font-size: 1.3vw;height: 8vw;}
    .align {flex-wrap: nowrap;justify-content: space-between}
    p {}
    a {}
    b{}
  }
  @media screen and (min-width: 1140px) {
    footer {height: 90px;font-size: 14px;}
    .align {}
    p {}
    a {}
    b{}
  }
</style>
